import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import dayjs from 'dayjs';
import { User } from 'src/app/models/user.model';
import { ApiService } from 'src/app/services/api.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-assign-new-guard-dialog',
  templateUrl: './assign-new-guard-dialog.component.html',
  styleUrls: ['./assign-new-guard-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatButton,
  ],
})
export class AssignNewGuardDialogComponent implements OnInit {
  protected fb = inject(FormBuilder);
  dialogRef = inject<MatDialogRef<AssignNewGuardDialogComponent>>(MatDialogRef);
  data = inject<{
    company_product_id: string;
    from: dayjs.Dayjs;
    to: dayjs.Dayjs;
  }>(MAT_DIALOG_DATA);
  private api = inject(ApiService);

  form: FormGroup;
  users: User[] = [];

  constructor() {
    this.form = this.fb.group({
      user_id: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.fetchPotentialGuards();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  submit() {
    this.api
      .assignCompanyProductGuardianScheduledWeek(this.data.company_product_id, this.form.value.user_id, this.data.from.format('YYYY-MM-DD'))
      .subscribe(data => {
        this.dialogRef.close(true);
      });
  }

  private fetchPotentialGuards() {
    this.api.getActiveCompanyProductMembers(this.data.company_product_id, { date: this.data.from.toDate() }).subscribe(data => {
      this.users = data.map(member => member.user as User);
    });
  }
}
